import { LitElement, css, html, type PropertyValues } from "lit";
import { customElement, property, state } from "lit/decorators.js";
import { unsafeHTML } from "lit/directives/unsafe-html.js";

@customElement("cpl-markdown-viewer")
export class CplMarkdownViewer extends LitElement {
  @property({ type: String }) value = "";
  @state() private rendered = "";
  private revision = 0;
  static styles = css`
    :host {
      display: block;
      min-width: 0;
      color: inherit;
      font: inherit;
      overflow-wrap: anywhere;
    }
    .document {
      line-height: 1.5;
    }
    p:first-child {
      margin-top: 0;
    }
    p:last-child {
      margin-bottom: 0;
    }
    pre {
      overflow: auto;
      max-height: 32rem;
      background: #fff;
      padding: 8px;
      border: 2px solid;
      border-color: #808080 #fff #fff #808080;
      white-space: pre;
    }
    code,
    pre {
      font-family: Consolas, "Courier New", monospace;
      font-size: 13px;
    }
    code {
      background: #eee;
    }
    pre code {
      background: transparent;
    }
    a {
      color: #000080;
      text-decoration: underline;
    }
    a:focus-visible {
      outline: 1px dotted #000;
    }
    table {
      border-collapse: collapse;
      display: block;
      overflow: auto;
    }
    th,
    td {
      border: 1px solid #808080;
      padding: 4px 8px;
      text-align: left;
    }
    th {
      background: #c0c0c0;
    }
    blockquote {
      border-left: 3px solid #808080;
      margin-left: 0;
      padding-left: 12px;
    }
    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      line-height: 1.3;
      margin: 1em 0 0.5em;
    }
    h1 {
      font-size: 1.5em;
    }
    h2 {
      font-size: 1.3em;
    }
    h3 {
      font-size: 1.15em;
    }
    .token.comment {
      color: #606060;
    }
    .token.keyword,
    .token.boolean {
      color: #000080;
    }
    .token.string {
      color: #800000;
    }
    .token.number {
      color: #008000;
    }
    ::-webkit-scrollbar {
      width: 16px;
      height: 16px;
    }
    ::-webkit-scrollbar-track {
      background: #dfdfdf;
    }
    ::-webkit-scrollbar-thumb {
      background: #c0c0c0;
      border: 2px solid;
      border-color: #fff #808080 #808080 #fff;
    }
  `;
  protected async updated(changes: PropertyValues) {
    if (!changes.has("value")) return;
    const revision = ++this.revision;
    const { sanitizedMarkdown } = await import("./classic-markdown-engine");
    if (revision === this.revision)
      this.rendered = sanitizedMarkdown(this.value);
  }
  render() {
    return html`<div class="document">${unsafeHTML(this.rendered)}</div>`;
  }
}
